import React from 'react';
import Relay from 'react-relay';
import { connect } from 'react-redux';

import { closeLogin, closeDownload } from 'depop/state/navigation';

import Footer from 'depop/components/layout/navigation/Footer';
import Header from 'depop/components/layout/navigation/Header';

import DesktopOnly from 'depop/components/layout/DesktopOnly';

import LazyModal from 'depop/components/modal/LazyModal';

import Fixit from 'depop/components/Fixit';

import { pure } from 'recompose';

class AppNavigation extends React.Component {
  props: {
    viewer: Object,
    hideHeader: boolean,
    hideFooter: boolean,
  };

  render() {
    const {
      viewer,
      hideHeader,
      hideFooter,
      closeLogin,
      closeDownload,
      navigation: { isLoginOpen, isDownloadOpen },
    } = this.props;

    return (
      <div>
        {
          !hideHeader ?
          <Fixit>
            {isFixed => <Header isFixed={isFixed} viewer={viewer} />}
          </Fixit>
          : null
        }
        <LazyModal
          isOpened={isLoginOpen}
          onClose={closeLogin}
          load={() =>
            import('../../../components/login/Login').then(
              module => module.default,
            )}
          render={Login => <Login closeModal={closeLogin} />}
        />
        <LazyModal
          isOpened={isDownloadOpen}
          onClose={closeDownload}
          load={() =>
            import('../../../components/download/DownloadModal').then(
              module => module.default,
            )}
          render={DownloadModal => <DownloadModal onClose={closeDownload} />}
        />
        {!hideFooter && <DesktopOnly><Footer /></DesktopOnly>}
      </div>
    );
  }
}

const mapStateToProps = ({ userAgent, overlays, navigation }) => ({
  userAgent,
  overlays,
  navigation,
});

const mapDispatchToProps = dispatch => {
  return {
    closeLogin: () => dispatch(closeLogin()),
    closeDownload: () => dispatch(closeDownload()),
  };
};

const connectedView = connect(mapStateToProps, mapDispatchToProps)(
  AppNavigation,
);

export default Relay.createContainer(pure(connectedView), {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        ${Header.getFragment('viewer')}
        currentUser {
          publicId
          username
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/root/containers/components/AppNavigation.js